<script>
    import R, {LOADER} from "../../lib/requests";
    import {setFocusTo} from "../../lib/lib";
    import Modal from '../../components/modal/Modal.svelte';
    import Notifier from "../../stores/notifier";

    export let groupId = null;
    export let closeCallback;

    let group = null;

    const initialize = () => {
        if (groupId == 0) {
            group = {
                id: 0,
                // code: '',
                name: '',
            }
            setFocusTo('groupName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            group = result;
            setFocusTo('groupName');
        };

        const onFailure = err => {
        };

        R.handle(R.analysisGroup.details, groupId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Η ομάδα αναλύσεων ενημερώθηκε");
            close(result);
        }

        const onFailure = err => {

        };

        group.name = group.name.trim();
        if (!group.name) {
            Notifier.showError("Πληκτρολογήστε το όνομα της ομάδας");
            setFocusTo("groupName");
            return;
        }

        let action = groupId == 0 ? 'create' : 'edit';
        R.handle(R.analysisGroup[action], group, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        group = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if group}
    <Modal title="Λογαριασμός Χρήστη" on:close="{ close }">
        <div slot="body">
<!--            <div class="form-group">-->
<!--                <label>Κωδικός</label>-->
<!--                <input type="text" class="form-control" id="groupCode" bind:value="{ group.code }" autocomplete="off">-->
<!--            </div>-->
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="groupName" bind:value="{ group.name }" autocomplete="off">
            </div>
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}